import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import messages from '../../../messages';
import ControlContainer from '../../../../components/ControlContainer';
import P from '../../../../../../components/P';
import FlexBox from '../../../../../../components/FlexBox';
import OptionsContainer from '../../../../components/OptionsContainer';
import RadioInput from './RadioInput';

const WarningSection = ({
  showWarningMissingRequiredDocument,
  showWarningInvalidRequiredDocument,
  warningMissingRequiredDocument,
  isReadOnly,
  handleChange,
  intl,
}) => {
  if (!showWarningMissingRequiredDocument && !showWarningInvalidRequiredDocument) {
    return null;
  }

  return (
    <div className="row">
      <div className="form-group col-md-12">
        <ControlContainer>
          {showWarningMissingRequiredDocument && (
            <div>
              <h5 style={{ fontWeight: 'bold', color: 'red' }}>
                <FormattedMessage {...messages.warningMissingRequiredDocument} />
              </h5>
              <P>
                <FormattedMessage {...messages.warningMissingRequiredDocumentText1} />
              </P>
            </div>
          )}

          {showWarningInvalidRequiredDocument && (
            <div>
              <h5 style={{ fontWeight: 'bold', color: 'red' }}>
                <FormattedMessage {...messages.warningInvalidRequiredDocument} />
              </h5>
              <P>
                <FormattedMessage {...messages.warningInvalidRequiredDocumentText1} />
              </P>
            </div>
          )}

          <div className="row">
            <div className="form-group col-md-12">
              <FlexBox>
                <OptionsContainer>
                  <FormattedMessage {...messages.wouldYouLikeToProceedToNextSteps} />
                </OptionsContainer>
                <RadioInput
                  name="warningMissingRequiredDocument"
                  value="true"
                  checked={warningMissingRequiredDocument === 'true'}
                  onChange={handleChange('form.warningMissingRequiredDocument')}
                  disabled={isReadOnly}
                  message={messages.yes}
                />
                <RadioInput
                  name="warningMissingRequiredDocument"
                  value="false"
                  checked={warningMissingRequiredDocument === 'false'}
                  onChange={handleChange('form.warningMissingRequiredDocument')}
                  disabled={isReadOnly}
                  message={messages.no}
                />
              </FlexBox>
            </div>
          </div>
        </ControlContainer>
      </div>
    </div>
  );
};

WarningSection.propTypes = {
  showWarningMissingRequiredDocument: PropTypes.bool.isRequired,
  showWarningInvalidRequiredDocument: PropTypes.bool.isRequired,
  warningMissingRequiredDocument: PropTypes.string.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(WarningSection);



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepDeclaration/components/SubmitClaim/components/WarningSection.js